import {autoinject} from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import {CargoTypeDistributionModel} from "../../../../../models/vetting/vetting.models";
import * as Enumerable from "linq";

@autoinject
export class CargoTypesDialog {

    public item: CargoTypeDistributionModel[] = [];

    public cargoUnits: string[] = [];
    public cargoTypeWithUnits: any;
    public periods: number[] = [];
    public isQuarterly: boolean = true;

    constructor(private dialogClientService: DialogClientService){

    }
    
    activate(model: any) {
        if (model.items) {
            this.item = model.items;
            this.isQuarterly = model.isQuarterly;
        } else {
            this.item = model;
        }
        this.cargoUnits = Enumerable.from(this.item)
            .select(x => x.cargoUnit)
            .distinct()
            .toArray();
        this.periods = Enumerable.from(this.item)
            .select(x => x.periodValue)
            .distinct()
            .toArray()
            .sort();
    }

    cargoTypesWithUnits(cargoUnit: string): any[] {
        const cargoTypesOfUnit = this.item.filter(x=> x.cargoUnit == cargoUnit);

        const result = [];
        cargoTypesOfUnit.filter(function(item){
            const i = result.findIndex(x => (x.cargoType == item.cargoType && x.cargoUnit == item.cargoUnit));
            if(i <= -1){
                result.push(item);
            }
            return null;
        });
        return result;
    }
    
    close(){
        this.dialogClientService.hide();
    }
    
    getGhgEmission(cargoUnit: string, cargoType: string, periodValue : number) : number{
        return Enumerable.from(this.item)
            .where(x => x.cargoUnit == cargoUnit && x.cargoType == cargoType && x.periodValue == periodValue)
            .select(x => x.totalGhgEmissions)
            .firstOrDefault();
    }

    getTotalGhgEmissions(periodValue: number, cargoUnit: string): number {
        return Enumerable.from(this.item)
            .where(x=> x.cargoUnit == cargoUnit && x.periodValue == periodValue)
            .sum(x=> x.totalGhgEmissions);
    }

    getGrandTotalGhgEmissions(periodValue: number) {
        return Enumerable.from(this.item)
            .where(x=> x.periodValue == periodValue)
            .sum(x=> x.totalGhgEmissions);
    }
}